import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminJournal = lazy(() => import("@/pages/admin/AdminJournal"));

export const Route = createFileRoute("/admin/journal")({
  component: AdminJournal,
});
